// @flow
import type { Request } from '../../../index';

type PaimentOrderExport = {
  customer_id: number,
  payment_order_id: number,
  format: 'pdf',
}

export const GET_PAYMENT_ORDER_EXPORT: Request<PaimentOrderExport, void> = [
  'cafeteria/customer/payment_orders/export',
  'get',
  [],
];
